export enum CostGranularity {
    Month = "period",
    Quarter = "quarter",
    Year = "year"
}
